import React from "react";
import styles from "./mobile-property-documents.module.scss";
import { MobilePropertyFeaturesProps } from "./mobile-property-features.interface";
import FeaturesTag from "../../features-tag";
import { DocumentViewed } from "../../../investor/amplitude";
import { useParams, useSearchParams } from "react-router-dom";
import useContextHook from "../../../../hooks/context/useContext";

const MobilePropertyDocumnets = ({
  title,
  type,
  objPropertyDetails
}: MobilePropertyFeaturesProps) => {
  const { propertyId } = useParams();
  const { mobileNumber } = useContextHook();
  const [searchParams] = useSearchParams();
  const cid = searchParams.get("cid") || "";
  const eq = searchParams.get("eq") || "";
  function getLabel(label: string) {
    let newLabel = "";
    if (label === "realistic_report") {
      newLabel = "Get Realist Report";
    } else if (label === "inspection_report") {
      newLabel = "Inspection";
    } else if (label === "comparables_report") {
      newLabel = "View Comparables";
    } else if (label === "disclosures_report") {
      newLabel = "Disclosures";
    }
    return newLabel;
  }

  function getIcon(label: string) {
    let iconUrl = "";
    if (label === "realistic_report") {
      iconUrl = "/images/disclosures.svg";
    } else if (label === "inspection_report") {
      iconUrl = "/images/note.svg";
    } else if (label === "comparables_report") {
      iconUrl = "/images/note.svg";
    } else if (label === "disclosures_report") {
      iconUrl = "/images/disclosures.svg";
    }
    return iconUrl;
  }

  const documentArray: any[] = [];
  objPropertyDetails.docs.forEach(
    (element: { url: string; type: string }, index: number) => {
      documentArray.push({
        id: index,
        label: getLabel(element?.type),
        icon: getIcon(element?.type),
        url: element.url
      });
    }
  );

  const openInNewTab = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };
  return (
    <div className={styles.propertyFeatures} tabIndex={16}>
      <div className={styles.title} tabIndex={17}>
        {title}
      </div>

      <div className={styles.featuresWrap}>
        {documentArray?.map((feat: any, index: number) => {
          return (
            <div
              key={index}
              onClick={() => {
                openInNewTab(feat.url);
                if (type === "investor") {
                  DocumentViewed({
                    DocumentUrl: feat.url,
                    DocumentName: feat.label,
                    propertyId: objPropertyDetails?.propertyId,
                    opportunitySFID: objPropertyDetails?.opportunitySFID,
                    pubPropertySFID: objPropertyDetails?.pubPropertySFID,
                    propertySFID: objPropertyDetails?.propertySFID,
                    shareId: propertyId || "",
                    linkCId: cid,
                    linkEmailId: eq,
                    mobileNumber: mobileNumber
                  });
                }
              }}
            >
              {feat.url && (
                <FeaturesTag
                  value={feat.num}
                  label={feat.label}
                  images={feat.icon}
                  url={feat.url}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default React.memo(MobilePropertyDocumnets);
